import * as React from "react";
import Svg, { Rect, G, Path, Defs, ClipPath } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Rect width={42} height={42} rx={4.2} fill="#F3F5FC" />
    <G clipPath="url(#clip0_997_6783)">
      <Path
        opacity={0.2}
        d="M11.25 25.4999V23.3559C11.25 17.9671 15.5766 13.5187 20.9653 13.4999C22.2486 13.4954 23.5202 13.7442 24.7071 14.2321C25.8941 14.7201 26.973 15.4375 27.882 16.3434C28.7911 17.2492 29.5124 18.3256 30.0045 19.5107C30.4967 20.6959 30.75 21.9666 30.75 23.2499V25.4999C30.75 25.6989 30.671 25.8896 30.5303 26.0303C30.3897 26.1709 30.1989 26.2499 30 26.2499H12C11.8011 26.2499 11.6103 26.1709 11.4697 26.0303C11.329 25.8896 11.25 25.6989 11.25 25.4999Z"
        fill="#1434CB"
      />
      <Path
        d="M11.25 25.4999V23.3559C11.25 17.9671 15.5766 13.5187 20.9653 13.4999C22.2486 13.4954 23.5202 13.7442 24.7071 14.2321C25.8941 14.7201 26.973 15.4375 27.882 16.3434C28.7911 17.2492 29.5124 18.3256 30.0045 19.5107C30.4967 20.6959 30.75 21.9666 30.75 23.2499V25.4999C30.75 25.6989 30.671 25.8896 30.5303 26.0303C30.3897 26.1709 30.1989 26.2499 30 26.2499H12C11.8011 26.2499 11.6103 26.1709 11.4697 26.0303C11.329 25.8896 11.25 25.6989 11.25 25.4999Z"
        stroke="#1434CB"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M21 13.5V16.5"
        stroke="#1434CB"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M18.75 26.25L24.75 18"
        stroke="#1434CB"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M27.75 21.75H30.6356"
        stroke="#1434CB"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M11.3804 21.75H14.2501"
        stroke="#1434CB"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_997_6783">
        <Rect width={24} height={24} fill="white" transform="translate(9 9)" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
